import { z } from 'zod';
import { PAGINATION, ROLES } from '../../constants/index.js';
import { objectIdSchema } from '../common.js';
export const roleSchema = z.enum(ROLES);
/**
 * Foydalanuvchi (TZ 3.2).
 *
 * `passwordHash` va `refreshTokenHash` HECH QACHON public mapper'dan o'tmaydi
 * (docs/03-CONVENTIONS.md §2).
 */
export const userSchema = z.object({
    _id: objectIdSchema,
    email: z.string().trim().toLowerCase().email('Elektron pochta noto‘g‘ri').max(200),
    passwordHash: z.string().min(1),
    fullName: z.string().trim().min(1).max(200),
    role: roleSchema,
    isActive: z.boolean().default(true),
    lastLoginAt: z.coerce.date().nullable().default(null),
    refreshTokenHash: z.string().nullable().default(null),
    failedLoginAttempts: z.number().int().min(0).default(0),
    lockedUntil: z.coerce.date().nullable().default(null),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
/** Admin panelda ko'rinadigan ko'rinish — maxfiy maydonlarsiz. */
export const userViewSchema = userSchema.omit({
    passwordHash: true,
    refreshTokenHash: true,
    failedLoginAttempts: true,
});
export const createUserSchema = z.object({
    email: z.string().trim().toLowerCase().email().max(200),
    password: z
        .string()
        .min(10, 'Parol kamida 10 belgi bo‘lishi kerak')
        .max(200)
        .regex(/[a-z]/, 'Kichik harf bo‘lishi kerak')
        .regex(/[A-Z]/, 'Katta harf bo‘lishi kerak')
        .regex(/\d/, 'Raqam bo‘lishi kerak'),
    fullName: z.string().trim().min(1).max(200),
    role: roleSchema,
    isActive: z.boolean().default(true),
});
export const updateUserSchema = createUserSchema.partial().omit({ password: true });
export const loginSchema = z.object({
    email: z.string().trim().toLowerCase().email().max(200),
    password: z.string().min(1).max(200),
    recaptchaToken: z.string().max(4000).optional(),
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1).max(200),
    newPassword: createUserSchema.shape.password,
});
/** Superadmin boshqa foydalanuvchining parolini almashtiradi (eski parolsiz). */
export const resetPasswordSchema = z.object({
    newPassword: createUserSchema.shape.password,
});
export const listUsersQuerySchema = z.object({
    page: z.coerce.number().int().min(1).max(PAGINATION.MAX_PAGE).default(1),
    limit: z.coerce.number().int().min(1).max(PAGINATION.MAX_LIMIT).default(PAGINATION.DEFAULT_LIMIT),
    role: roleSchema.optional(),
    isActive: z
        .enum(['true', 'false'])
        .transform((v) => v === 'true')
        .optional(),
    search: z.string().trim().max(200).optional(),
});
/**
 * Access token ichidagi ma'lumot. `@CurrentUser()` shu tipni qaytaradi.
 *
 * Parol yoki refresh token bilan bog'liq hech narsa BU YERGA TUSHMAYDI —
 * token brauzerda ochiq o'qiladi.
 */
export const accessTokenPayloadSchema = z.object({
    sub: objectIdSchema,
    email: z.string(),
    role: roleSchema,
    fullName: z.string(),
});
/**
 * Refresh token ichidagi ma'lumot.
 *
 * `jti` — rotatsiya uchun: har yangilanishda yangi `jti` beriladi va uning
 * hashi bazaga yoziladi. Eski token bilan kelinsa hash mos kelmaydi →
 * qayta ishlatish aniqlanadi (TZ 11.2).
 */
export const refreshTokenPayloadSchema = z.object({
    sub: objectIdSchema,
    jti: z.string().min(1),
});
//# sourceMappingURL=user.js.map